import axios from "axios";

export default {
	getRecentActivity(limit) {
		let ctx = {};
		if (limit) {
			ctx.limit = limit;
		}
		return axios.get(`/v3/unread+responses`, { params: ctx });
	},

	getUsersCurrentActivity(ctx) {
		return axios.get(`/v3/activity/current/users`, { params: ctx });
	}
};



// WEBPACK FOOTER //
// ./src/services/ActivityService.js